import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ordinal from "ordinal"
import {
    faChevronRight,
    faChevronLeft
} from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";

export default ({ data, activeSlide, setActiveSlide, logoKaBackgrounds }) => {

    const next = () =>
        activeSlide < data.length - 1 && setActiveSlide(activeSlide + 1);

    const prev = () => activeSlide > 0 && setActiveSlide(activeSlide - 1);

    const getStyles = (index) => {
        if (activeSlide === index)
            return {
                opacity: 1,
                transform: "translateX(0px) translateZ(0px) rotateY(0deg)",
                zIndex: 10
            };
        else if (activeSlide - 1 === index)
            return {
                opacity: 1,
                transform: "translateX(-240px) translateZ(-400px) rotateY(35deg)",
                zIndex: 9
            };
        else if (activeSlide + 1 === index)
            return {
                opacity: 1,
                transform: "translateX(240px) translateZ(-400px) rotateY(-35deg)",
                zIndex: 9
            };
        else if (activeSlide - 2 === index)
            return {
                opacity: 1,
                transform: "translateX(-480px) translateZ(-500px) rotateY(35deg)",
                zIndex: 8
            };
        else if (activeSlide + 2 === index)
            return {
                opacity: 1,
                transform: "translateX(480px) translateZ(-500px) rotateY(-35deg)",
                zIndex: 8
            };
        else if (index < activeSlide - 2)
            return {
                opacity: 0,
                transform: "translateX(-480px) translateZ(-500px) rotateY(35deg)",
                zIndex: 7
            };
        else if (index > activeSlide + 2)
            return {
                opacity: 0,
                transform: "translateX(480px) translateZ(-500px) rotateY(-35deg)",
                zIndex: 7
            };
    };


    useEffect(()=>{
        console.log(data)
    },[])

    return (
        <>
            {/* carousel */}
            <div className="slideC">
                {data.map((item, i) => (
                    <React.Fragment key={item.id}>
                        <div
                            className="slide"
                            style={{
                                // background: item.bgColor,
                                // boxShadow: `0 5px 20px ${item.bgColor}30`,
                                ...getStyles(i)
                            }}
                        >
                            <div className='d-flex flex-column justify-content-start align-items-center bg-light shadow w-100' style={{ borderRadius: "1.5em", padding: "1.2em" }}>
                                <div className='position-relative' style={item.eventType === "birthday" ? logoKaBackgrounds[0] : logoKaBackgrounds[1]}>
                                    {
                                        item.eventType !== "birthday" ?
                                            <span className='position-absolute workYearsForExp'>{ordinal(parseInt(`${dayjs().format("YYYY") - dayjs(item.DOJ.formatted).format("YYYY")}`))}</span>
                                            :
                                            ""
                                    }
                                    <button className='btn btn-outline-dark rounded-circle overflow-hidden p-0 m-0 border-0' style={{ height: "5em", aspectRatio: "1/1" }}>
                                        {/* <img src={"https://picsum.photos/300/300?random=" + key} style={{ height: "100%", width: "100%", objectFit: "contain", borderRadius: "100%" }} /> */}


                                        <img src={
                                            `https://placehold.co/300x300/fffaef/000000?text=${item.name.split(" ").map((words, key) => { return words.split("")[0] }).join("+").toUpperCase()}`
                                        }
                                            alt={item.name} style={{ height: "100%", width: "100%", objectFit: "contain", borderRadius: "100%" }} />
                                    </button>
                                </div>
                                <span className='text-center' style={{ fontSize: "2em" }} >{item.name}</span>
                                <span className='text-muted w-100 text-truncate text-center' title={item.email} style={{ fontSize: "1.5em" }}>{item.email}</span>
                                <span className='text-muted' style={{ fontSize: "1.5em" }}>{item.department}</span>
                                <span className='text-muted' style={{ fontSize: "1.5em" }}>{item.eventType === "birthday" ? dayjs(item.DOB.value).format("DD MMMM") : dayjs(item.DOJ.value).format("DD MMMM")}</span>
                            </div>
                        </div>
                    </React.Fragment>
                ))}
            </div>
            {/* carousel */}

            <div className="w-100 d-flex justify-content-center">
                <FontAwesomeIcon
                    className="btn text-secondary"
                    onClick={prev}
                    icon={faChevronLeft}
                    // color="#fff"
                    size="2x"
                />
                <FontAwesomeIcon
                    className="btn text-secondary"
                    onClick={next}
                    icon={faChevronRight}
                    color="#fff"
                    size="2x"
                />
            </div>
        </>
    );
};
